import { AccountPassword } from './AccountPassword';
import { connect } from 'react-redux';
import {
  accountViewActions,
  accountCurrentPasswordSel,
  accountNewPasswordRepeatSel,
  accountNewPasswordSel,
  accountNewPasswordValidationSel,
  accountViewErrorSel,
  accountViewIsPendingSel
} from 'src/store/modules/accountview';
import { withI18n } from 'react-i18next';

const mapStateToProps = (state: any) => {
  return {
    isLoading: accountViewIsPendingSel(state),
    hasError: accountViewErrorSel(state).hasFailed,
    currentPassword: accountCurrentPasswordSel(state),
    newPassword: accountNewPasswordSel(state),
    newPasswordRepeat: accountNewPasswordRepeatSel(state),
    passwordValidation: accountNewPasswordValidationSel(state)
  };
};

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  onCurrentPasswordChange: (value: string) =>
    dispatch(accountViewActions.setCurrentPassword(value)),
  onNewPasswordChange: (value: string) =>
    dispatch(accountViewActions.setNewPassword(value)),
  onNewPasswordRepeatChange: (value: string) =>
    dispatch(accountViewActions.setNewPasswordRepeat(value)),
  onChangePassword: (cb?: (result: boolean) => void) =>
    dispatch(accountViewActions.changePassword(cb)),
  onClearError: () => dispatch(accountViewActions.setError())
});

export const pureComponent = AccountPassword;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(AccountPassword));

interface IDispatchFromProps {
  onCurrentPasswordChange(value: string): void;
  onNewPasswordChange(value: string): void;
  onNewPasswordRepeatChange(value: string): void;
  onChangePassword(cb?: (result: boolean) => void): void;
  onClearError(): void;
}
